import { render, staticRenderFns } from "./MilkFeedingPage.vue?vue&type=template&id=7069c2b5&scoped=true&"
import script from "./MilkFeedingPage.vue?vue&type=script&lang=js&"
export * from "./MilkFeedingPage.vue?vue&type=script&lang=js&"
import style0 from "./MilkFeedingPage.vue?vue&type=style&index=0&id=7069c2b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7069c2b5",
  null
  
)

export default component.exports